<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 25">
    <g fill="none" fill-rule="evenodd" transform="translate(-31.32 -20)">
        <path class="widget-icon--status" fill="#FFF" fill-rule="nonzero" d="M52.383 31.433L37.256 21.306c-.39-.226-.87-.226-1.26 0-.401.202-.665.602-.694 1.05V42.61c.001.467.258.895.668 1.114.401.207.882.183 1.26-.063l15.128-10.127c.349-.235.558-.63.558-1.05 0-.422-.21-.816-.558-1.051h.025z"/>
    </g>
</svg>
